import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Modal,
  Alert,
  Image,
  FormControl,
} from "react-bootstrap";
import {
  ListarPromocoes,
  CadastrarPromocoes,
  EditarPromocao,
  DeletarPromocao,
} from "../../providers/PromocoesProvider";
import { api_url_promocoes_image } from "../../providers/api";
import { getUser } from "../../services/Auth";
import { toast } from "react-toastify";
import TBLPromocoes from "../../components/TBLPromocoes";
import { ListarEstabelecimentosSemPaginacao } from "../../providers/EstabelecimentoProvider";
import Select from "react-select";

export default class Promocoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promocaoSelecionada: null,
      showModalPromocoes: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarPromocao: false,
      pages: 1,
      page: 1,
      limit: 10,
      promocoes: [],
      promocoesList: [],
      descricao: "",
      imagem: null,
      busca: "",
      mensagemAlert: "",
      variantAlert: "",
      carregarDadosTabela: true,
      estabelecimentos: [],
      estabelecimentoSelecionado: null,
    };

    this.fileInput = null;
  }

  handleCloseModalPromocoes = () => {
    this.setState({ showModalPromocoes: false });
    this.limparForm();
  };

  handleShowModalPromocoes = () => {
    this.setState({ showModalPromocoes: true });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else {
      toast.error(mensagem);
    }
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };

  fileChangedHandler = (event) => {
    this.setState({ imagem: event.target.files[0] });
  };

  limparForm = () => {
    this.setState({
      promocaoSelecionada: null,
      showModalPromocoes: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarPromocao: false,
      estabelecimentoSelecionado: null,

      descricao: "",
      imagem: null,

      mensagemAlert: "",
      variantAlert: "",
    });
  };

  preencherFormEdit = (dados) => {
    this.setState({
      promocaoSelecionada: dados,
      descricao: dados.descricao,
      modoEditarPromocao: true,
      estabelecimentoSelecionado: {
        label: dados.estabelecimento?.nome_fantasia,
        value: dados.estabelecimento?._id,
      },
    });
    this.handleShowModalPromocoes();
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      this.preencherFormEdit(dados);
    } else if (tipo === "deletar") {
      this.setState({ promocaoSelecionada: dados });
      this.handleShowModalAlert();
    } else {
      return;
    }
  };

  cadastrarPromocao = async () => {
    let form = new FormData();
    let { descricao, imagem, estabelecimentoSelecionado } = this.state;
    if (descricao === "" || imagem === null || estabelecimentoSelecionado == null) {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
    } else {
      form.append(`descricao`, descricao);
      form.append(`estabelecimento`, estabelecimentoSelecionado?.value);
      form.append(`imagem`, imagem);
      try {
        const response = await CadastrarPromocoes(form);
        if (response) {
          this.listarPromocoes();
          this.limparForm();
          this.handleShowAlert("Promoção cadastrada com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao cadastrar promoção", "danger");
      }
    }
  };

  editarPromocao = async () => {
    let form = new FormData();
    let formJson = {};
    let { descricao, imagem, promocaoSelecionada } = this.state;
    if (descricao === "") {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
    } else {
      if (imagem) {
        form.append(`imagem`, imagem);
        form.append(`descricao`, descricao);
      } else {
        formJson = {
          descricao: descricao,
        };
      }
      try {
        let response = null;
        if (imagem) {
          response = await EditarPromocao(form, promocaoSelecionada._id);
        } else {
          response = await EditarPromocao(formJson, promocaoSelecionada._id);
        }
        if (response) {
          this.listarPromocoes();
          this.limparForm();
          this.handleShowAlert("Promoção editada com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao cadastrar promoção", "danger");
      }
    }
  };

  deletarPromocao = async () => {
    const { promocaoSelecionada } = this.state;
    try {
      const response = await DeletarPromocao(promocaoSelecionada._id);
      if (response) {
        this.listarPromocoes();
        this.limparForm();
        this.handleShowAlert("Promoção excluida com sucesso", "success");
      }
    } catch (error) {
      this.handleShowAlert("Erro ao excluir promoção", "danger");
    }
  };

  listarPromocoes = async () => {
    const promocoes = await ListarPromocoes();
    this.setState({ promocoes, promocoesList: promocoes });
    return promocoes;
  };

  buscarPromocoes = (busca) => {
    if (busca) {
      const response = this.state.promocoesList.filter((p) =>
        p.estabelecimento.nome_fantasia.toLowerCase().includes(busca.toLowerCase()),
      );
      this.setState({ promocoes: response });
    } else {
      const list = this.state.promocoesList;
      this.setState({ promocoes: list });
    }
  };

  getEstabelecimentos = async () => {
    const promos = this.state.promocoesList;
    const data = await ListarEstabelecimentosSemPaginacao();
    if (data) {
      this.setState({
        estabelecimentos: data
          .filter((e) => !promos.some((p) => p.estabelecimento._id === e._id))
          .map((e) => ({
            label: e.nome_fantasia,
            value: e._id,
          })),
      });
    }
  };

  async componentDidMount() {
    await this.listarPromocoes();
    await this.getEstabelecimentos();
  }

  render() {
    return (
      <div style={{ margin: 10, marginLeft: 50, marginRight: 50 }}>
        {this.state.showAlert ? (
          <Alert style={{ zIndex: 99999999999 }} variant={this.state.variantAlert}>
            {this.state.mensagemAlert}
          </Alert>
        ) : null}
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Banner de Promoções</h3>
          </Col>
          <Col>
            <Button
              onClick={() => {
                this.handleShowModalPromocoes();
              }}
            >
              Cadastrar Banner
            </Button>
          </Col>
        </Row>
        <br></br>

        {this.state.promocoes.length ? (
          <div>
            <div>
              <FormControl
                placeholder="Pesquisar promoção por estabelecimento"
                onChange={(e) => this.buscarPromocoes(e.target.value)}
              />
              <TBLPromocoes
                data={this.state.promocoes}
                numRows={10}
                dataCallback={this.receberDadosTabela}
                showAcoes
              ></TBLPromocoes>
            </div>
          </div>
        ) : (
          <h5>Nenhuma promoção cadastrada</h5>
        )}

        <Modal
          size="xl"
          show={this.state.showModalPromocoes}
          onHide={this.handleCloseModalPromocoes}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.modoEditarPromocao
                ? "Editar banner de promoção"
                : "Cadastrar banner de promoção"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.modoEditarPromocao ? (
              <div style={{ width: "100%", textAlign: "center", marginBottom: 20 }}>
                <Image
                  rounded
                  style={{ width: 60, height: 60 }}
                  src={
                    api_url_promocoes_image + this.state.promocaoSelecionada.foto_promocao
                  }
                ></Image>
              </div>
            ) : null}
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group>
                <Form.Label>Estabelecimento *</Form.Label>
                <Select
                  isDisabled={this.state.modoEditarPromocao}
                  value={this.state.estabelecimentoSelecionado}
                  onChange={(opt) => {
                    this.setState({
                      estabelecimentoSelecionado: opt,
                    });
                  }}
                  options={this.state.estabelecimentos}
                  placeholder="Escolha o estabelecimento"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Descrição *</Form.Label>
                <Form.Control
                  value={this.state.descricao}
                  type="text"
                  placeholder="Descrição da promoção"
                  onChange={(e) => {
                    this.setState({ descricao: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Imagem Banner *</Form.Label>
                <input
                  className={"form-control"}
                  type="file"
                  accept="image/x-png,image/gif,image/jpeg"
                  ref={(ref) => (this.fileInput = ref)}
                  onChange={this.fileChangedHandler}
                ></input>
                <Form.Text>
                  O banner deve ter as seguinter dimensões - Largura: 600px, Altura: 300px
                </Form.Text>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalPromocoes();
              }}
            >
              Fechar
            </Button>
            {this.state.modoEditarPromocao ? (
              <Button
                variant="primary"
                onClick={() => {
                  this.editarPromocao();
                }}
              >
                {"Editar"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarPromocao();
                }}
              >
                {"Cadastrar"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir a o banner de promoção?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarPromocao();
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
